import { render, staticRenderFns } from "./EditClientDetails.vue?vue&type=template&id=24a2200c&"
import script from "./EditClientDetails.vue?vue&type=script&lang=js&"
export * from "./EditClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports